import type { Customer } from "@/resources/customer";
import { apiClient } from "./apiClient";

class CustomerService {
  async getById(id: string): Promise<Customer | null> {
    try {
      const response = await apiClient.get<Customer>(`/customers/${id}`);
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      console.warn("Customer API returned unexpected status:", response.status);
      return null;
    } catch (error) {
      console.error("Failed to fetch customer:", error);
      return null;
    }
  }

  async updateById(id: string, data: Partial<Customer>): Promise<boolean> {
    try {
      const response = await apiClient.put(`/customers/${id}`, data);
      return response.status === "OK";
    } catch (error) {
      console.error("Failed to update customer:", error);
      return false;
    }
  }
}

export const customerService = new CustomerService();
